export const CLASS_NAMES = {
  container: 'flex flex-1 flex-col item-start',
  wrapper: 'px-6 py-8 border border-neutral-300 rounded-lg',
};
